export class Reclamation {
    _id:string;
    ref:string;
    refprefixe:string;
    userId: string;
    deadline:number
    transactions:[];
   // changements:[];
    created: Date;
    updated: Date;
    statut:[]
   /* statut:{
        item:string,
        date:number,
        acteur:string,
        changements:[]
    }*/
}
